import { useState } from "react";

const Avatar = props => {
  const { label, src, size = "sm", onClick = () => {} } = props || {};
  // Tracks the most-recently-failed src so we can fall back to initials
  // without permanently disabling the avatar — when `src` next changes
  // to something different we re-render the <img> and try again.
  const [failedSrc, setFailedSrc] = useState(null);
  const initials =
    label
      ?.split(" ")
      ?.map(item => item[0])
      ?.join("") || "";

  const sizeMap = {
    sm: "h-6 w-6",
    "sm-2": "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-12 w-12",
  };
  const sizeClass = sizeMap[size] || sizeMap?.sm;
  const showImage = Boolean(src) && failedSrc !== src;

  return (
    <span
      className={`inline-flex items-center justify-center ${sizeClass} rounded-full shadow-[inset_0_0_0_2px_rgb(55,65,81)] group-hover:shadow-[inset_0_0_0_2px_rgb(107,114,128)]`}
      onClick={onClick}
      role="button"
      tabIndex={0}
    >
      <span className="text-xs font-bold leading-none text-gray-700 group-hover:text-gray-500">
        {showImage ? (
          <img
            className={`rounded-full object-cover ${sizeClass}`}
            src={src}
            onError={() => setFailedSrc(src)}
          />
        ) : (
          initials
        )}
      </span>
    </span>
  );
};

export { Avatar };
